import { render, staticRenderFns } from "./Blends.vue?vue&type=template&id=a2c6cc6a&"
import script from "./Blends.vue?vue&type=script&lang=js&"
export * from "./Blends.vue?vue&type=script&lang=js&"
import style0 from "./Blends.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports